import React from 'react'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'
import DetailDoctorService from '../Service/DetailDoctorService'
import './doctortreatment.css'

export default class formInput extends React.Component {

    render() {
        const {saveHandler, ShowModal, ShowModalEdit, ShowModalEditBerhasil, ShowModalAlert, ShowModalfunc, text,
            noneHandler, cancelHandler, editHandler, changeHandler, Mode, list_sp, ganti, alertHandler} = this.props

        return (
            <div>
            <div class="mb-10">

                <Modal show={ShowModal} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode}</Modal.Title>
                        {/* {JSON.stringify(list_sp)} */}
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-3 ">
                            <label for="name" class="form-label tindakan">Spesialisasi *</label>
                            <select class="form-select lebar abu" style={{ height: 40 }} id="spesialisasi" value={list_sp._id} onChange={changeHandler("specialization_id")}>
                                <option selected hidden>{text}</option>
                                {list_sp.map(data => {
                                    return (
                                        <option value={data._id}>{data.name}</option>
                                    )
                                })}
                            </select>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        <button type="button" class="btn btn-primary" onClick={editHandler}>Simpan</button>
                    </Modal.Footer>
                </Modal>
            </div>
            
            <div class="mb-10">
                <Modal show={ShowModalEditBerhasil} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Sukses</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/success.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p>Anda berhasil memperbarui Spesialis. </p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Kembali</button>
                    </Modal.Footer>
                </Modal>
            </div>

            <div class="mb-10">
                <Modal show={ShowModalAlert} onHide={alertHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Gagal</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/sent.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p>Spesialis tidak boleh Kosong / Sama dengan sebelumnya. </p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={alertHandler}>Kembali</button>
                    </Modal.Footer>
                </Modal>
            </div>

            <div class="mb-10">
            <Modal show={ShowModalEdit} onHide={cancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Spesialisasi</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="modal-body text-center hapus">
                            <img src="assets/img/sent.png" alt="" width="50" height="46" />
                            <p> </p>
                            <p class="margintext">Anda setuju untuk memperbarui</p>
                            <p class="margintext">Spesialis Menjadi '{ganti}' ?</p>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={cancelHandler}>Batal</button>
                        <button class="btn btn-danger" onClick={saveHandler} >Yakin</button>
                    </Modal.Footer>
                </Modal>
            
            </div>
            </div>
        )
    }
}
